window.QuotationScroll = {
  init() {
    const quoteButton = document.getElementById('productQuotation');
    const quoteForm = document.getElementById('quotation-form');

    if (quoteButton && quoteForm) {
      quoteButton.addEventListener('click', (e) => {
        e.preventDefault();
        quoteForm.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.QuotationScroll) {
    window.QuotationScroll.init();
  }
});